import { FunctionComponent } from 'react';
import List from '@mui/material/List';
import { useFilterBlockItemComponent } from '../_hooks/useFilterBlockItemComponent';
import { IFilterBlockItemsProps } from './FilterBlockItems.interface';

export const FilterBlockItems: FunctionComponent<IFilterBlockItemsProps> = (props) => {
  const { items, depth } = props;

  const FilterBlockItemComponent = useFilterBlockItemComponent();

  return (
    <List sx={{ padding: 0 }}>
      {items.map((item) => {
        return (
          <FilterBlockItemComponent
            key={item.value}
            item={item}
            depth={depth}
          />
        );
      })}
    </List>
  );
};
